import React from 'react';
import { Table } from 'semantic-ui-react';
import RoomTypeColorCell from './RoomTypeColorCell';

const RoomTypeRow = ({ item }) => (
  <Table.Row>
    <Table.Cell>{item.roomNumber}</Table.Cell>
    <Table.Cell>{item.roomTypeName}</Table.Cell>
    <Table.Cell>{item.revenueCy}</Table.Cell>
    <Table.Cell>{item.revenuePy}</Table.Cell>
    <RoomTypeColorCell value={item.revenueDiff} />
    <Table.Cell>{item.nightsCy}</Table.Cell>
    <Table.Cell>{item.nightsPy}</Table.Cell>
    <RoomTypeColorCell value={item.nightsDiff} />
    <Table.Cell>{item.avgOcc}</Table.Cell>
    <Table.Cell>{item.avgOccPy}</Table.Cell>
    <RoomTypeColorCell value={item.avgOccDiff} />
    <Table.Cell>{item.adr}</Table.Cell>
    <Table.Cell>{item.adrPy}</Table.Cell>
    <RoomTypeColorCell value={item.adrDiff} />
    <Table.Cell>{item.ownerNightsCy}</Table.Cell>
    <Table.Cell>{item.ownerNightsPy}</Table.Cell>
    <RoomTypeColorCell value={item.ownerNightsDiff} />
    <Table.Cell>{item.newOwnerUseValue}</Table.Cell>
    <Table.Cell>{item.newOwnerUseValuePy}</Table.Cell>
    <RoomTypeColorCell value={item.newOwnerUseValueDiff} />
  </Table.Row>
);

export default React.memo(RoomTypeRow);
